import i18n, {
  FALLBACK_LANGUAGE,
  SUPPORTED_LANGUAGES,
  type SupportedLanguage,
} from '@/lib/i18n/config';

const isSupportedLanguage = (value: string): value is SupportedLanguage => {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
};

export const getCurrentLanguage = (): SupportedLanguage => {
  const language = i18n.resolvedLanguage ?? i18n.language;
  const normalized = (language ?? FALLBACK_LANGUAGE).split('-')[0];
  return isSupportedLanguage(normalized) ? normalized : FALLBACK_LANGUAGE;
};
